import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";
import { EventUtil } from "../../util/EventUtil";
import { SubSpecialtySelect } from "../healioGlobal/SubSpecialtySelect";

export class ViewBySubSpecialty extends Component {

    private _selectedSubspecialty = "";

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
    }

    public async init(): Promise<void> {
        let context = this._pageContext;
        if (!context) {
            throw new Error("No page context");
        }

        let selectedSubspecialty = this._element.dataset.subspecialtyId;
        if (selectedSubspecialty) {
            this._selectedSubspecialty = selectedSubspecialty;
        }

        // re-using this event since the landing card layout is already listening for it
        this._element.dispatchEvent(EventUtil.createCustomEvent(SubSpecialtySelect.SubSpecialtySelectInitEvent, null));
    }

    public get subspecialty(): string {
        return this._selectedSubspecialty;
    }
}

ComponentFactory.registerComponent("ViewBySubSpecialty", ViewBySubSpecialty);
